export default __webpack_public_path__ + "static/media/Big-Data-PT.91690219.jpg";